import React from "react";

import Coin from "@svg/billing/Coin";
import ReferralPanelBackground from "@svg/referral-panel-background";

import { ArrowUpRight, Check, Link, MousePointerClick } from "lucide-react";

type AffiliateShareCardProps = {
  shareUrl: string | null;
  isCopied: boolean;
  onCopy: () => void;
  onOpenLink: () => void;
};

export const AffiliateShareCard = ({
  shareUrl,
  isCopied,
  onCopy,
  onOpenLink,
}: AffiliateShareCardProps) => {
  return (
    <div className="relative rounded-xl border-0.5 border-black/10 shadow-2xs overflow-hidden">
      <ReferralPanelBackground className="absolute inset-0 w-full h-full" />
      <div className="relative h-[93px]">
        <svg
          className="absolute right-[117px] top-[26px]"
          width="44"
          height="52"
          viewBox="0 0 44 34"
          fill="none"
        >
          <path
            d="M8 0V26C8 30 11 33 15 33H44"
            stroke="white"
            strokeOpacity="0.75"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute bg-white/50 backdrop-blur-[0.8px] border-[2.5px] border-white/50 rounded-md shadow-2xs right-[50px] top-[10px] px-1.5 py-1 flex items-center justify-between w-[118px]">
          <div className="flex items-center gap-1">
            <Link size={10} className="text-default" />
            <span className="text-[9px] font-medium text-default">
              Your link
            </span>
          </div>
          <div className="flex items-center gap-0.5">
            <MousePointerClick size={7} className="text-muted" />
            <span className="text-[8px] text-muted">Clicks</span>
          </div>
        </div>
        <div className="absolute bg-white/50 backdrop-blur-[0.8px] border-[3px] border-white/50 rounded-md shadow-sm -right-[20px] top-[44px] p-1.5 flex items-center gap-1.5 w-[139px]">
          <Coin className="w-6 h-6 -rotate-[10deg] shrink-0" />
          <div className="flex flex-col">
            <span className="text-[8px] text-muted">Monthly Earnings</span>
            <span className="text-[11px] font-semibold text-default">$$$</span>
          </div>
        </div>
        <div className="relative flex flex-col gap-0.5 px-3 pb-1 justify-end h-full">
          <h4 className="header-h6 text-default">Share & Earn</h4>
          <p className="text-xs text-muted">for every click on your link</p>
        </div>
      </div>
      <div className="relative p-3">
        <div className="bg-white rounded-lg shadow-sm p-2 h-10 flex items-center gap-4">
          <button
            type="button"
            onClick={onOpenLink}
            className="flex-1 min-w-0 flex items-center gap-1 text-xs font-medium text-default hover:underline cursor-pointer bg-transparent border-none p-0 text-left"
          >
            <span className="truncate">
              {shareUrl?.replace(/^https?:\/\//, "")}
            </span>
            <ArrowUpRight size={14} className="shrink-0" />
          </button>
          <button
            type="button"
            onClick={onCopy}
            className="bg-default text-white text-xs font-medium rounded-md px-2 h-6 w-[76px] flex items-center justify-center gap-1"
          >
            {isCopied ? <Check size={14} /> : "Copy Link"}
          </button>
        </div>
      </div>
    </div>
  );
};
